var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canAccess)?_c('router-link',_vm._b({attrs:{"title":_vm.title,"to":_vm.route},nativeOn:{"click":function($event){return _vm.handleHash($event)}}},'router-link',_vm.$attrs,false),[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }